export default __webpack_public_path__ + "static/media/qr-code-animate.c8d42c05.svg";